import { semanticColors } from "../../../utils/colors";
import { typography } from "../../../utils/typography";

// Field styling shared with the rest of the app lives in utils/fieldStyles;
// re-exported here so the video-consultation components keep their local import.
export {
  outlinedFieldSx,
  outlinedFieldMultilineSx,
  searchIconSx,
  warningOutlineSx
} from "../../../utils/fieldStyles";

/**
 * Picker popup styling. Portuguese month and weekday names come lowercased from
 * moment, so capitalise the calendar header, the month list and the toolbar.
 */
export const pickerPaperSx = {
  "& .MuiPickersCalendarHeader-label, & .MuiPickersMonth-monthButton, & .MuiDayCalendar-weekDayLabel, & .MuiPickersToolbar-content": {
    textTransform: "capitalize"
  }
};

/** Autocomplete dropdown option styling. */
export const autocompleteOptionSx = {
  "& .MuiAutocomplete-option": {
    ...typography.body.l,
    color: semanticColors.text.primary
  }
};
